module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/casestudy-avatar-02-a0de683324963e162ac3a3ec0f46e001.png";